module.exports = __webpack_public_path__ + "static/media/authImage.8f634a6e.jpg";